<div class="offlineContent">
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
    <path d="M2.5 8.5a15 15 0 0 1 19 0" />
    <path d="M5.5 12a10.5 10.5 0 0 1 13 0" />
    <path d="M8.5 15.5a6 6 0 0 1 7 0" />
    <circle cx="12" cy="19" r="1" fill="currentColor" />
    <line x1="3" y1="3" x2="21" y2="21" />
  </svg>
  <h1>{{ texts.title }}</h1>
  <p>{{ texts.description }}</p>
  <button type="button" class="retryButton" (click)="retry()">{{ texts.retry }}</button>
</div>
